export default __webpack_public_path__ + "static/media/background.18d58f6a.png";